(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-simple-buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rr-simple-buy-now')) {
    customElements.define('rr-simple-buy-now', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.checkoutForm = this.querySelector('form');
        this.button = this.querySelector('button');
        if (!this.productInfo || !this.checkoutForm) return;
        this.onSubmit = (event) => {
          const sourceForm = this.productInfo.querySelector('product-form form');
          const variant = sourceForm?.querySelector('input[name="id"]');
          const quantity = this.productInfo.querySelector('quantity-input input[name="quantity"]');
          if (!variant || variant.disabled || !variant.value || (quantity && !quantity.reportValidity())) {
            event.preventDefault();
            this.sync();
            return;
          }
          this.checkoutForm.querySelector('[name="id"]').value = variant.value;
          this.checkoutForm.querySelector('[name="quantity"]').value = quantity?.value || '1';
          this.checkoutForm.querySelectorAll('[data-rr-copied]').forEach((input) => input.remove());
          for (const [name, value] of new FormData(sourceForm)) {
            if (name === 'selling_plan' || name.startsWith('properties[')) {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = name;
              input.value = value;
              input.dataset.rrCopied = '';
              this.checkoutForm.append(input);
            }
          }
        };
        this.checkoutForm.addEventListener('submit', this.onSubmit);
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => !this.contains(record.target))) this.sync();
        });
        this.observer.observe(this.productInfo, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'value'] });
        this.sync();
      }
      sync() {
        const variant = this.productInfo.querySelector('product-form input[name="id"]');
        const disabled = !variant || variant.disabled || !variant.value;
        if (this.button.disabled !== disabled) this.button.disabled = disabled;
        const label = disabled ? this.dataset.soldOutLabel : this.dataset.label;
        if (this.button.textContent.trim() !== label) this.button.textContent = label;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.checkoutForm?.removeEventListener('submit', this.onSubmit);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-simple-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rr-simple-gallery')) {
    customElements.define('rr-simple-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const controller = this.controller;
        customElements.whenDefined('media-gallery').then(() => {
          if (!this.isConnected || this.controller !== controller || controller.signal.aborted) return;
          this.gallery = this.closest('product-info')?.querySelector('media-gallery');
          const viewer = this.gallery?.querySelector('[id^="GalleryViewer"]');
          if (!viewer || typeof this.gallery.setActiveMedia !== 'function') return;
          this.nav?.remove();
          this.nav = document.createElement('div');
          this.nav.className = 'rr-simple-gallery-nav';
          for (const [delta,label,symbol] of [[-1,this.dataset.previous,'‹'],[1,this.dataset.next,'›']]) {
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('aria-label',label);
            button.setAttribute('aria-controls',viewer.id);
            const icon = document.createElement('span');
            icon.setAttribute('aria-hidden','true');
            icon.textContent = symbol;
            button.append(icon);
            button.addEventListener('click',() => this.move(delta),{signal:this.controller.signal});
            this.nav.append(button);
          }
          viewer.append(this.nav);
          this.observer = new MutationObserver(() => this.refresh());
          this.observer.observe(viewer,{childList:true,subtree:true});
          this.refresh();
        });
      }
      items() {
        return [...this.gallery.querySelectorAll('[id^="GalleryViewer"] [data-media-id]')].filter(el => el.matches('.product__media-item') && !el.classList.contains('product__media-item--variant'));
      }
      refresh() { if (this.nav) this.nav.hidden = this.items().length < 2; }
      move(delta) {
        const items = this.items();
        if (items.length < 2) return;
        const current = Math.max(0,items.findIndex(el => el.classList.contains('is-active')));
        this.gallery.setActiveMedia(items[(current + delta + items.length) % items.length].dataset.mediaId,false);
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.nav?.remove(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
